import { render, staticRenderFns } from "./pesoParaLaEdadNinos0a2A.vue?vue&type=template&id=1532f278&scoped=true&"
import script from "./pesoParaLaEdadNinos0a2A.vue?vue&type=script&lang=js&"
export * from "./pesoParaLaEdadNinos0a2A.vue?vue&type=script&lang=js&"
import style0 from "./pesoParaLaEdadNinos0a2A.vue?vue&type=style&index=0&id=1532f278&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1532f278",
  null
  
)

export default component.exports